// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseRolloutActionStatus = {
  RolloutActionStatusPending: 'PENDING',
  RolloutActionStatusApplied: 'APPLIED',
} as const;
export type ResponseRolloutActionStatus =
  (typeof ResponseRolloutActionStatus)[keyof typeof ResponseRolloutActionStatus];

export function instanceOfResponseRolloutActionStatus(value: any): boolean {
  for (const key in ResponseRolloutActionStatus) {
    if (
      Object.prototype.hasOwnProperty.call(ResponseRolloutActionStatus, key)
    ) {
      if (
        ResponseRolloutActionStatus[
          key as keyof typeof ResponseRolloutActionStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseRolloutActionStatusFromJSON(
  json: any,
): ResponseRolloutActionStatus {
  return ResponseRolloutActionStatusFromJSONTyped(json, false);
}

export function ResponseRolloutActionStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutActionStatus {
  return json as ResponseRolloutActionStatus;
}

export function ResponseRolloutActionStatusToJSON(
  value?: ResponseRolloutActionStatus | null,
): any {
  return value as any;
}

export function ResponseRolloutActionStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutActionStatus {
  return value as ResponseRolloutActionStatus;
}
